import { render, staticRenderFns } from "./TipoModalidadeForm.vue?vue&type=template&id=36c73527"
import script from "./TipoModalidadeForm.vue?vue&type=script&lang=js"
export * from "./TipoModalidadeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports